module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1s"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_04_ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9781607052029_06_intro"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9781607052029_07_basic"
    }
  }, [_vm._v("Basic Supplies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_08_color",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Color and Design")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("What Color Is “Christmas”?, Contrast and Value, Designs on Fabric, Choosing Fabric for a Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Projects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_10_chirist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas in the Park")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_11_the",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The All Wonderful Red & Green Quilt")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_12_caribbean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caribbean Christmas")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_13_circular",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circular Momentum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_14_atreat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Treat before Takeoff!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_15_thestock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stockings Were Hung by the Chimney with Care")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_16_perky",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perky Partridge Pincushion/Ornament")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_17_generalquilt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Quiltmaking Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Fabric Preparation, Seam Allowances, Finishing the Quilt, Making Continuous Bias Strips, Sewing the Binding to the Quilt, Making a Label and Sleeve, Signing Your Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_18_general",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Appliqué Instructions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Preparing the Backgrounds for Appliqué, Making Appliqué Templates, Using the Templates, Making the Positioning Overlay, Using the Positioning Overlay, Finger-Pressing, Pressing and Trimming the Blocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_19_special",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Appliqué Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Cutaway Appliqué, Circle Appliqué")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_20_author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "green4"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052029_21_source",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a40ff3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607052029_05_toc.vue
// module id = 72
// module chunks = 0